module.exports = __webpack_public_path__ + "static/img/60eecbc9a9f07354964015e5e72f66b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fw_sjgj.png
// module id = Z6P1
// module chunks = 1